export default __webpack_public_path__ + "static/media/roger-keller.25de90ae.jpg";